import Http from '../../http';
import {
  ADD_PAYOUT,
  CLOSE_CASH_REGISTER,
  FETCH_ACTIVE_REGISTER,
  FETCH_CASH_REGISTER_HISTORY,
  OPEN_CASH_REGISTER,
  OPEN_CASH_REGISTER_DRAWER,
} from './constants';
import { downloadCsv } from '../../main/reports/helpers';

const fetchActiveRegisterAction = register => ({
  type: FETCH_ACTIVE_REGISTER,
  payload: register,
});

const fetchActiveRegister = url => dispatch => Http.get(url, {}, false)
  .then(data => dispatch(fetchActiveRegisterAction(data)))
  .catch(() => dispatch(fetchActiveRegisterAction(false)));

export const fetchShopActiveRegister = shopId => fetchActiveRegister(`/shop/${shopId}/cash-register/active`);
export const fetchBarberActiveRegister = barberId => fetchActiveRegister(`/barber/${barberId}/cash-register/active`);

const openCashRegisterAction = payload => ({
  type: OPEN_CASH_REGISTER,
  payload,
});

const openCashRegister = (url, startBalance) => dispatch =>
  Http.post(url, { startBalance })
    .then(data => dispatch(openCashRegisterAction(data)));
export const openShopCashRegister =
  (shopId, startBalance) => openCashRegister(`/shop/${shopId}/cash-register/open`, startBalance);
export const openBarberCashRegister =
  (barberId, startBalance) => openCashRegister(`/barber/${barberId}/cash-register/open`, startBalance);


const closeCashRegisterAction = payload => ({
  type: CLOSE_CASH_REGISTER,
  payload,
});

export const openCashRegisterDrawer = () => ({
  type: OPEN_CASH_REGISTER_DRAWER,
});

const closeCashRegister = (url, { notes, actualEndBalance }) => dispatch =>
  Http.post(url, { notes, actualEndBalance })
    .then((data) => {
      dispatch(openCashRegisterDrawer());
      return dispatch(closeCashRegisterAction(data));
    });
export const closeShopCashRegister = (shopId, notes) => closeCashRegister(`/shop/${shopId}/cash-register/close`, notes);
export const closeBarberCashRegister =
  (barberId, notes) => closeCashRegister(`/barber/${barberId}/cash-register/close`, notes);

const addPayoutAction = payload => ({
  type: ADD_PAYOUT,
  payload,
});

const addPayout = (url, data) => dispatch =>
  Http.post(url, data)
    .then(response => dispatch(addPayoutAction(response)));
export const addShopPayout = (shopId, data) => addPayout(`/shop/${shopId}/cash-register/subtract`, data);
export const addBarberPayout = (barberId, data) => addPayout(`/barber/${barberId}/cash-register/subtract`, data);

export const addShopPayin = (shopId, data) => addPayout(`/shop/${shopId}/cash-register/add`, data);
export const addBarberPayin = (barberId, data) => addPayout(`/barber/${barberId}/cash-register/add`, data);

const fetchCashRegisterHistoryAction = payload => ({
  type: FETCH_CASH_REGISTER_HISTORY,
  payload,
});

const fetchCashRegisterHistory = url => dispatch =>
  Http.get(url, { include: 'transactions' })
    .then(data => dispatch(fetchCashRegisterHistoryAction(data)));
export const fetchShopCashRegisterHistory = shopId => fetchCashRegisterHistory(`/shop/${shopId}/cash-register`);
export const fetchBarberCashRegisterHistory =
  barberId => fetchCashRegisterHistory(`/barber/${barberId}/cash-register`);
export const downloadCashRegisterHistory = (ownerType, ownerId, name) => Http
  .getRaw(`/${ownerType}/${ownerId}/cash-register`, { include: 'transactions', view: 'csv' })
  .then(response =>
    downloadCsv(
      response,
      `${name} - Balance history report`
    )
  );

const fetchLastClosedCashRegister = url => dispatch =>
  Http.get(url, { include: 'transactions', limit: 1, sortBy: 'closedAt:desc' })
    .then(data => dispatch(fetchCashRegisterHistoryAction(data)));
export const fetchShopLastClosedCashRegister = shopId => fetchLastClosedCashRegister(`/shop/${shopId}/cash-register`);
export const fetchBarberLastClosedCashRegister =
  barberId => fetchLastClosedCashRegister(`/barber/${barberId}/cash-register`);
